import uri from 'urijs'
import { after } from './../utility/transition'
import { html as dom, empty } from './../utility/html'

const formData = form => {
	return [].reduce.call(form.elements || [], (data, element) => {	
		if (!element.name) return data;
		if (element.type === 'checkbox' || element.type === 'radio') {
			if (element.checked) data[element.name] = element.value || null
		} else {
			data[element.name] = element.value;
		}
		return data;
	}, {});
}


export default function init() {

	const items = [...document.querySelectorAll('[data-programmes-filter]')]
	const form = document.querySelector('.js-programmes-filter-desktop')
	const formMobile = document.querySelector('.js-programmes-filter-mobile')

	if (!form || !formMobile) return;
	
	const container = document.querySelector('.js-programmes-container')

	const infoContainer = document.querySelector('[data-programmes-filter-info]')
	const titles = JSON.parse(infoContainer.getAttribute('data-programmes-filter-info')) || {}

	const statusEl = document.querySelector('.js-programmes-status--desktop')
	const statusElMobile = document.querySelector('.js-programmes-status--mobile')

	
	;[form, formMobile].map(x => x.addEventListener('submit', e => e.preventDefault()))

	const data = formData(form)
	const url = uri(window.location.href)
	
	const inputChange = event => {
		const { name, value, type, checked } = event.currentTarget
		if (type === 'checkbox') {
			if (checked) data[name] = value
			if (!checked) data[name] = null
		} else {
			data[name] = value || null
		}

		const els = [
			...form.querySelectorAll(`input[name=${name}]`), 
			...formMobile.querySelectorAll(`input[name=${name}]`)
		]

		els.filter(el => el.value === value).map(el => {
			if (el.type === 'checkbox') {
				el.checked = !!data[name]
			} else {
				el.checked = true
			}
		})

		run()
	}

	const updateUrl = () => {
		for (const key in data) {
			if (data[key] === null) {
				url.removeQuery(key)
			} else {
				url.setQuery(key, data[key])
			}
			
		}
		history.replaceState({}, '', url);
	}


	const show = (slug, hideClosed = true) => {

		container.style.minHeight = `${container.clientHeight}px`;

		const hide = [], show = [];

		items.map(el => {

			el.classList.add('transition-02')

			const isClosed = el.getAttribute('data-programmes-closed') !== null
			if (isClosed && hideClosed) {
				hide.push(el)
				return
			}

			const subjects = (el.getAttribute('data-programmes-filter') || "").split(',')
			const isMatched = !slug || subjects.indexOf(slug) > -1

			if (isMatched) {
				show.push(el)
				el.__programmesShow = true
			}
			if (!isMatched) {
				hide.push(el)
				el.__programmesShow = false
			}
		})

		// hide all
		items.map(el => {
			el.classList.add('minify')
			setTimeout(function() {
				el.classList.add('hide')
			}, 200);
		})

		// show matched
		setTimeout(() => {
			show.map(el => {
				el.classList.add('minify')
				el.classList.remove('hide')
				el.getBoundingClientRect()
				el.classList.remove('minify')
			})

			container.style.minHeight = '';
		}, 210)

		return show.length
	}

	const status = (count, open = true, mobile = false, key = '') => {

		const programmes = count === 1 ? 'programme' : 'programmes'

		if (titles[key] === undefined) return `
			<p>Showing ${!open && count > 2 && 'all' || ''} <strong>${count}</strong> ${programmes}</p>
		`

		return `<p>
			Showing ${!open && count > 2 && 'all' || ''} <strong>${count}</strong> ${programmes} in 
			<span class="${mobile && 'show margin-top-1' || ''}"><span class="text-highlight">${titles[key]}</span></span>
		</p>`
	}

	const run = () => {
		updateUrl()
		const count = show(data.subject, data.open === 'yes')
		statusEl.innerHTML = status(count, data.open === 'yes', false, data.subject)
		statusElMobile.innerHTML = status(count, data.open === 'yes', true, data.subject)
	}

	run();

	[form, formMobile].map(form => {
		const inputs = [...form.querySelectorAll('input[type=radio], input[type=checkbox]')]
		inputs.map(input => input.addEventListener('change', inputChange))
	})


}